import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=70ecd58c&scoped=true&"
import script from "./CustomerManage.vue?vue&type=script&lang=js&"
export * from "./CustomerManage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManage.vue?vue&type=style&index=0&id=70ecd58c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecd58c",
  null
  
)

export default component.exports